module.exports = __webpack_public_path__ + "static/img/__1231.79b4500.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__1231.jpg
// module id = dIGA
// module chunks = 0